import SearchDropdown from "../../../../../../common/compositions/InputComposition/dropdown.types/SearchDropdown/SearchDropdown";

import React from "react";
import { ClipLoader } from "react-spinners";

const DelegateEmployeesDropdown = (
    {
        items,
        message,
        isLoading,
        loadError,
        onRetry,
        ...icProps
    },
) => {
    if (loadError) {
        return (
            <div className={"delegation-transfer__list-state"}>
                <span>Не удалось загрузить список, попробуйте ещё раз</span>
                <button type="button" onClick={onRetry} className={"delegation-transfer__list-state__retry"}>
                    Повторить
                </button>
            </div>
        );
    }

    if (isLoading) {
        return (
            <div className={"delegation-transfer__list-state"}>
                <ClipLoader size={20} color={"#6DCDF6"} />
            </div>
        );
    }

    return <SearchDropdown {...icProps} message={message} items={items} />;
};

export default DelegateEmployeesDropdown;